module.exports = __webpack_public_path__ + "static/images/dialog-gift-btn-ok2.a7f5684.png";